<template>
  <div class="dol-row" :style="{height:height}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "dol-row",
    props: {
      height: {style: String, default: ''}
    },
    data() {
      return {};
    },
    watch: {},
    methods: {},
    created() {
    },
  }
</script>

<style scoped>
  .dol-row {
    height: 100%;
    margin: 0 -10px;
    overflow: hidden;
    display: flex;
  }
</style>
